import { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { setUser, resetUser } from './UserSlice';
import { resetSubscription } from '../subscription/SubscriptionSlice';
import { handleFetchSubscriptionDetails } from '../subscription/SubscriptionService';
import { store } from '../../app/store';
import { useNavigate, useLocation } from 'react-router-dom';
import { LOGIN, PROFILE } from '../../routes/CONSTANTS';

//While auth is not requred to view pages wrapped in this component, they may behave differently
//when the user is logged in, so this wrapper is used to maintain that session.
export default function UsesSubscriptionInfo({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    //Restore redux store data after page refresh if the auth
    //session is still valid.
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user) {
          const formattedUser = {
            sub: user.attributes.sub,
            firstName: user.attributes.given_name,
            lastName: user.attributes.family_name,
            email: user.attributes.email,
            emailVerified: user.attributes.email_verified,
          };
          store.dispatch(setUser(formattedUser));
          handleFetchSubscriptionDetails();
          if (formattedUser.emailVerified !== true) {
            if (location.pathname !== PROFILE) {
              navigate(PROFILE);
            }
          }
        }
      })
      .catch(() => {
        if (localStorage.getItem('userWasLoggedIn') === 'true' ? true : false) {
          localStorage.setItem('userWasLoggedIn', 'false');
          navigate(LOGIN);
        }
        store.dispatch(resetUser());
        store.dispatch(resetSubscription());
      });
  });
  return children;
}
